import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useCompanyValidation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathCompanyName = decodeURIComponent(location.pathname.split("/")[1]);
    const storedCompany = localStorage?.getItem("companyName");
    const storedCompanyName = storedCompany
      ?.toLowerCase()
      ?.replace(/\s+/g, "-");
    const companyName = localStorage.getItem("companyName");
    if (!companyName) {
      navigate(`../`);
      return;
    }
    if (
      storedCompanyName &&
      pathCompanyName &&
      storedCompanyName.toLowerCase() !== pathCompanyName.toLowerCase()
    ) {
      navigate("/error-404");
    }
  }, [location, navigate]);
};

export default useCompanyValidation;
